import { useState } from 'react';
import { useErrorHandler } from '../../utils/useErrorHandler';
import dataProvider from '../../services/api';

export const useCityManagement = () => {
  const { handleErrorWithLogout } = useErrorHandler();
  
  const [cityOptions, setCityOptions] = useState<{ cityId: number; name: string; provinceId: number; provinceName: string }[]>([]);
  const [searchTerm, setSearchTerm] = useState('');

  const fetchInitialCities = async () => {
    try {
      const { data } = await dataProvider.getAllCitiesUser({ count: 100, page: 0 });
      setCityOptions(data.map((city: any) => ({
        cityId: city.cityId,
        name: city.name,
        provinceId: city.provinceId,
        provinceName: city.province?.name || '',
      })));
      setSearchTerm('');
    } catch (error: any) {
      handleErrorWithLogout(error);
    }
  };

  const handleCitySearch = async (value: string) => {
    setSearchTerm(value);
    if (value.length === 0) {
      await fetchInitialCities();
    } else if (value.length > 2) {
      try {
        const { data } = await dataProvider.lookupCitiesUser({ name: value, count: 100, page: 0 });
        setCityOptions(data.map((city: any) => ({
          cityId: city.cityId,
          name: city.name,
          provinceId: city.provinceId,
          provinceName: city.province?.name || '',
        })));
      } catch (error: any) {
        handleErrorWithLogout(error);
      }
    }
  };

  return {
    cityOptions,
    searchTerm,
    fetchInitialCities,
    handleCitySearch,
  };
};